import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { IEventSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IEventSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const { commonCodeStore } = useStores();
  const methods = useForm<IEventSFilter>({
    defaultValues: {
      eventTypeCd: null,
      searchText: '',
      useYn: null,
    },
  });
  const eventOptions =
    toJS(commonCodeStore.commonCodes)
      .find((item) => item.name === 'EVENT_TYPE_CD')
      ?.list.map((item) => ({
        value: item.code,
        label: item.value,
      })) || [];

  // 검색 함수
  const onValid = (data: IEventSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true}>
        <FormItem>
          <RHFSelect
            label={t('event.fields.eventTypeCd')}
            name="eventTypeCd"
            options={eventOptions}
          />
        </FormItem>
        <FormItem size={2}>
          <RHFTextField label={t('event.fields.searchText')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
